// src/redux/noticeSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_notice,
  add_notice,
  update_notice,
  delete_notice,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  notices: [],
  scrollnotices: [],
  hasmore:true,
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  scrollloading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: { 
    title:"",
    message: "",
    attach:null
  },
};



// Async Thunks for API Calls
export const fetchscrollnotice = createAsyncThunk(
  "notice/fetchscrollnotice",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_notice(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls
export const fetchnotice = createAsyncThunk(
  "notice/fetchnotice",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_notice(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createnotice = createAsyncThunk(
  "notice/createnotice",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_notice(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatenotice = createAsyncThunk(
  "notice/updatenotice",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_notice(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletenotice = createAsyncThunk(
  "notice/deletenotice",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_notice({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// notice Slice
const noticeboardSlice = createSlice({
  name: 'noticeboards',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, title,message } = action.payload;
      state.formData = { id, title,message  };
    },
    resetFormData(state) {
      state.formData = {
        title:"",
        message: "",
        attach:null
      };
    },
 

    setNotice(state, action) {
      state.noticeboards = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchscrollnotice.pending, (state) => {
      state.scrollloading = true;
    })
    .addCase(fetchscrollnotice.fulfilled, (state, action) => {
      const { results, total_pages,next } = action.payload;
      state.totalPages = total_pages;
      state.scrollloading = false;
      state.hasmore = next?true:false
      state.scrollnotices = [...state.scrollnotices, ...results];
    })
    .addCase(fetchscrollnotice.rejected, (state) => {
      state.scrollloading = false;
    })
       // Fetch notice
       .addCase(fetchnotice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchnotice.fulfilled, (state, action) => {
        state.loading = false;
        state.notices = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
   
      .addCase(fetchnotice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add notice
      .addCase(createnotice.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createnotice.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createnotice.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update notice
      .addCase(updatenotice.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatenotice.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatenotice.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete notice
      .addCase(deletenotice.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletenotice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletenotice.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const { setNotice,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = noticeboardSlice.actions;
export default noticeboardSlice.reducer;
